/* ==========================================================================
   Premium Horizon-style Theme — Global JavaScript (vanilla ES6, no deps)
   ========================================================================== */
document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', function () {
  initMobileNav();
  initCartDrawer();
  initSearchDrawer();
  initPredictiveSearch();
  initQuickAdd();
  initFooterAccordion();
  initStickyHeader();
});

/* -------------------------------------------------------------------------
   Mobile navigation slide-out
   ---------------------------------------------------------------------- */
function initMobileNav() {
  var toggle = document.querySelector('.site-header__mobile-toggle');
  var nav = document.querySelector('.mobile-nav');
  if (!toggle || !nav) return;

  function open() {
    nav.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    nav.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', open);
  nav.querySelectorAll('[data-mobile-nav-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
}

/* -------------------------------------------------------------------------
   Cart drawer: open/close + AJAX add-to-cart + quantity updates
   ---------------------------------------------------------------------- */
function initCartDrawer() {
  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;
  var toggles = document.querySelectorAll('.site-header__cart-toggle');

  function open() {
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  toggles.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      open();
    });
  });
  drawer.querySelectorAll('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  window.openCartDrawer = open;

  // Quantity change forms inside the drawer (progressive enhancement via fetch)
  drawer.addEventListener('submit', function (e) {
    var form = e.target.closest('form');
    if (!form) return;
    e.preventDefault();
    var formData = new FormData(form);
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(formData)
    })
      .then(function (res) { return res.json(); })
      .then(function () { window.location.reload(); })
      .catch(function (err) { console.error('Cart update failed', err); });
  });
}

/* -------------------------------------------------------------------------
   Search drawer
   ---------------------------------------------------------------------- */
function initSearchDrawer() {
  var drawer = document.getElementById('SearchDrawer');
  if (!drawer) return;
  var toggles = document.querySelectorAll('[id^="SearchToggle-"]');

  function open() {
    drawer.setAttribute('aria-hidden', 'false');
    var input = drawer.querySelector('[data-predictive-search-input]');
    if (input) setTimeout(function () { input.focus(); }, 100);
  }
  function close() {
    drawer.setAttribute('aria-hidden', 'true');
  }

  toggles.forEach(function (btn) {
    btn.addEventListener('click', function () { open(); });
  });
  drawer.querySelectorAll('[data-search-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
}

/* -------------------------------------------------------------------------
   Predictive search (Shopify /search/suggest.json)
   ---------------------------------------------------------------------- */
function initPredictiveSearch() {
  var input = document.querySelector('[data-predictive-search-input]');
  var resultsEl = document.querySelector('[data-predictive-search-results]');
  if (!input || !resultsEl) return;

  var debounceTimer;
  input.addEventListener('input', function () {
    var query = input.value.trim();
    clearTimeout(debounceTimer);
    if (query.length < 2) {
      resultsEl.innerHTML = '';
      return;
    }
    debounceTimer = setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            resultsEl.innerHTML = '<p class="predictive-search__empty">No results found.</p>';
            return;
          }
          resultsEl.innerHTML = products
            .map(function (p) {
              return (
                '<a class="predictive-search__item" href="' + p.url + '">' +
                (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') +
                '<span>' + p.title + '</span>' +
                '</a>'
              );
            })
            .join('');
        })
        .catch(function (err) { console.error('Predictive search failed', err); });
    }, 250);
  });
}

/* -------------------------------------------------------------------------
   Quick add to cart (product cards)
   ---------------------------------------------------------------------- */
function initQuickAdd() {
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quick-add-form]');
    if (!form) return;
    e.preventDefault();
    var button = form.querySelector('button[type="submit"]');
    var originalText = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding...';
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: new FormData(form).get('id'), quantity: 1 }]
      })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var countEls = document.querySelectorAll('[data-cart-count]');
        countEls.forEach(function (el) { el.textContent = cart.item_count; });
        if (button) button.textContent = 'Added ✓';
        if (window.openCartDrawer) window.openCartDrawer();
        setTimeout(function () {
          if (button) {
            button.disabled = false;
            button.textContent = originalText;
          }
        }, 1500);
      })
      .catch(function (err) {
        console.error('Quick add failed', err);
        if (button) {
          button.disabled = false;
          button.textContent = originalText;
        }
      });
  });
}

/* -------------------------------------------------------------------------
   Footer accordion (mobile)
   ---------------------------------------------------------------------- */
function initFooterAccordion() {
  document.querySelectorAll('[data-footer-accordion-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var col = btn.closest('.site-footer__accordion');
      if (!col) return;
      col.classList.toggle('is-open');
    });
  });
}

/* -------------------------------------------------------------------------
   Sticky header shrink-on-scroll (optional subtle effect)
   ---------------------------------------------------------------------- */
function initStickyHeader() {
  var header = document.querySelector('.site-header--sticky');
  if (!header) return;
  var lastScroll = 0;
  window.addEventListener(
    'scroll',
    function () {
      var current = window.scrollY;
      if (current > 40) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
      lastScroll = current;
    },
    { passive: true }
  );
}
